/******/ ;(() => {
  // webpackBootstrap
  class CartTerms extends HTMLElement {
    constructor() {
      super()
      this.termsElement = document.querySelector('[data-cart-terms]')
      this.checkForFinalSaleItems = this.checkForFinalSaleItems.bind(this)
      this.checkTerms = this.checkTerms.bind(this)
      this.cartForm = null
      this.termsCheckbox = this.querySelector('[data-cart-terms-checkbox]')
      this.isCartPage = window.location.pathname === '/cart'
    }

    getSelectors() {
      if (this.isCartPage) {
        return {
          form: 'form[action="/cart"]',
          checkoutButton: '.cart--button-checkout',
          cartForm: 'form[action="/cart"]',
          warning: '[data-cart-terms-warning]',
          warningIcon: '[data-cart-terms-warning-icon]',
          spinner: '.cart-button-checkout-spinner'
        }
      } else {
        return {
          form: '#CartDrawer-Form',
          checkoutButton: '.dynamic-section-button--drawer-filled.cart-drawer__footer--button',
          cartForm: '#CartDrawer-Form',
          warning: '[data-cart-terms-warning]',
          warningIcon: '[data-cart-terms-warning-icon]',
          spinner: '.cart-button-checkout-spinner'
        }
      }
    }

    connectedCallback() {
      window.wetheme.webcomponentRegistry.register({ key: 'component-cart-terms' })

      const selectors = this.getSelectors()

      // Listen for cart updates through the event bus
      window.eventBus.on('update:cart:drawer', this.checkForFinalSaleItems)

      // Add event listener to the checkout button
      const checkoutButton = document.querySelector(selectors.checkoutButton)
      if (checkoutButton) {
        checkoutButton.addEventListener('click', (event) => {
          // Pass the actual state of final sale items instead of hardcoded true
          const hasFinalSaleItems = !this.termsElement?.classList.contains('hide');
          this.checkTerms(event, hasFinalSaleItems);
        });
      }

      // Initial check once the cart form exists
      this.cartForm = document.querySelector(selectors.cartForm)
      if (this.cartForm) {
        this.checkForFinalSaleItems()
      } else {
        // Only observe until we find the cart form
        const observer = new MutationObserver(() => {
          const cartForm = document.querySelector(selectors.cartForm)
          if (cartForm) {
            this.cartForm = cartForm
            this.checkForFinalSaleItems()
            observer.disconnect() // Stop observing once we find the form
          }
        })

        observer.observe(document.body, {
          childList: true,
          subtree: true
        })
      }
    }

    checkTerms(event, hasFinalSale) {
      console.log('checkTerms', event, hasFinalSale)
      // Stop the event completely
      event.preventDefault()
      event.stopPropagation()
      event.stopImmediatePropagation()

      if (!hasFinalSale || !this.termsCheckbox) {
        // If there are no final sale items, redirect to checkout
        window.location.href = '/checkout'
        return true
      }

      if (!this.termsCheckbox.checked) {
        const selectors = this.getSelectors()

        // Query warning elements from the document
        const warning = document.querySelector(selectors.warning)
        const warningIcon = document.querySelector(selectors.warningIcon)
        const spinner = document.querySelector(selectors.spinner)

        // Show warnings
        warning?.classList.remove('hide')
        warningIcon?.classList.remove('hide')
        spinner?.classList.add('hide')

        return false
      }

      // If terms are checked, redirect to checkout
      window.location.href = '/checkout'
      return true
    }

    checkForFinalSaleItems() {
      if (!this.termsElement || !this.cartForm) return

      let showFinalSaleCheckbox = false

      if (this.cartForm.dataset.items) {
        try {
          const items = JSON.parse(this.cartForm.dataset.items)

          // Check each item for final_sale property
          items.forEach((item) => {
            if (item.properties && item.properties._final_sale === 'true') {
              showFinalSaleCheckbox = true
            }
          })
        } catch (e) {
          console.error('Error parsing cart items:', e)
        }
      }

      // Show/hide terms based on final sale items
      if (showFinalSaleCheckbox) {
        this.termsElement.classList.remove('hide')
      } else {
        this.termsElement.classList.add('hide')
      }
    }
  }

  customElements.define('cart-terms', CartTerms)
  /******/
})()
